import React, {RefObject} from 'react';
import { Swiper, SwiperRef } from "swiper/react";
import {Swiper as SwiperClass} from "swiper/types";

interface SwiperCarouselProps {
    isNextDisabled: boolean;
    disabled: boolean;
    setDisabled: (disabled: boolean) => void;
    setDisabledRight: (activeIndex: number) => void;
    sliderRef: RefObject<SwiperRef>;
    children: React.ReactNode;
}

const SwiperCarousel = ({
    isNextDisabled,
    disabled,
    setDisabled,
    setDisabledRight,
    sliderRef,
    children
}: SwiperCarouselProps) => {


    return (
        <>
            <Swiper
                spaceBetween={50}
                slidesPerView="auto"
                ref={sliderRef}
                onReachEnd={() => !isNextDisabled ? setDisabled(true) : console.log('')}
                onActiveIndexChange={(swiper: SwiperClass) => {
                    if (!isNextDisabled) {
                        setDisabledRight(swiper?.activeIndex)
                        if (disabled) setDisabled(false)
                    }
                }}
            >

                {children}
            </Swiper>
        </>
    )
}

export default SwiperCarousel